import React from "react";
import PurchasedLands from "@/components/Pages/Dashboard/PurchasedLands";

const PurchasedLandsPage: React.FC = () => {
  return <PurchasedLands />;
};
export default PurchasedLandsPage;
